import {
  IonHeader,
  IonContent,
  IonText,
  IonSkeletonText,
  IonToolbar,
  IonButtons,
  IonBackButton
} from '@ionic/react';

import classes from './style.module.scss';

const Loader = () => {
  return (
    <>
      <IonHeader className={classes.ionHeader}>
        <IonToolbar>
          <IonButtons slot='start'>
            <IonBackButton></IonBackButton>
          </IonButtons>
        </IonToolbar>
        <div className={classes.headContainer}>
          <IonSkeletonText style={{ width: '100%', height: '30vh' }} animated />
          <div className={classes.infoContainer}>
            <IonText className={classes.erTitle}>
              <IonSkeletonText
                style={{ width: '100%', height: '12px' }}
                animated
              />
            </IonText>
            <IonText className={classes.erSubTitle}>
              <IonSkeletonText
                style={{ width: '100%', height: '10px' }}
                animated
              />
            </IonText>
            <IonText className={classes.author}>
              <span className={classes.authorName}>
                <IonSkeletonText
                  style={{ width: '100%', height: '12px' }}
                  animated
                />
              </span>
            </IonText>
          </div>
        </div>
      </IonHeader>
      <IonContent className={classes.ionContent}>
        <IonSkeletonText animated style={{ width: '100%', height: '12px' }} />
        <IonSkeletonText animated style={{ width: '100%', height: '12px' }} />
        <IonSkeletonText animated style={{ width: '100%', height: '12px' }} />
        <IonSkeletonText animated style={{ width: '100%', height: '12px' }} />
        <IonSkeletonText animated style={{ width: '100%', height: '12px' }} />
        <IonSkeletonText animated style={{ width: '80%', height: '12px' }} />
      </IonContent>
    </>
  );
};

export default Loader;
